import { render, staticRenderFns } from "./messageBox.vue?vue&type=template&id=13cb1959&scoped=true&"
import script from "./messageBox.vue?vue&type=script&lang=js&"
export * from "./messageBox.vue?vue&type=script&lang=js&"
import style0 from "./messageBox.vue?vue&type=style&index=0&id=13cb1959&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cb1959",
  null
  
)

export default component.exports